import React from 'react';
import PropTypes from 'prop-types';

import QuestionText from '../QuestionText';

import { questionType, responseOptionType } from '../../constants/types';

import sharedStyles from '../../styles/shared';
import styles from './likertQuestion.module.css';
import { getTranslation } from '../../i18n';

const LikertQuestion = (
  {
    orderNum, question, onChange, errorState, lang, responseOptions, answer, translate: t
  }
) => {
  const handleChange = (event) => {
    onChange(event.target.name, Number(event.target.value));
  };

  const questionId = question.id;
  const questionElementId = `question_${questionId}`;
  const errorId = `err_${questionId}`;

  return (
    <div
      role="radiogroup"
      aria-labelledby={questionElementId}
      aria-required={question.required || undefined}
      aria-invalid={errorState && question.required ? 'true' : undefined}
      aria-describedby={errorState ? errorId : undefined}
      className={`${sharedStyles.row} ${styles.questionRow}`}
    >
      <QuestionText
        id={questionElementId}
        errorId={errorId}
        showError={errorState && question.required}
        question={question}
        orderNum={orderNum}
        lang={lang}
        translate={t}
      />
      {responseOptions.map((responseOption) => {
        const optionId = `${questionId}_${responseOption.id}`;
        const checked = responseOption.value === answer;
        const style = `${sharedStyles.option} ${sharedStyles.center} ${sharedStyles.centerVertical} ${styles.option}`;
        const labelText = getTranslation(responseOption.text, lang);
        return (
          <label className={style} key={optionId}>
            <span className={styles.optionInput}>
              <input
                aria-label={labelText}
                type="radio"
                name={questionId}
                id={optionId}
                value={responseOption.value}
                onChange={handleChange}
                checked={checked}
              />
            </span>
            <span className={styles.optionLabel} aria-hidden>{labelText}</span>
          </label>
        );
      })}
    </div>
  );
};

LikertQuestion.defaultProps = {
  answer: null
};

const {
  number, func, bool, string, arrayOf
} = PropTypes;
LikertQuestion.propTypes = {
  orderNum: number.isRequired,
  question: questionType.isRequired,
  onChange: func.isRequired,
  errorState: bool,
  lang: string.isRequired,
  translate: func.isRequired,
  responseOptions: arrayOf(responseOptionType).isRequired,
  answer: number
};

LikertQuestion.defaultProps = {
  errorState: false
};

export default LikertQuestion;
